import { useQuery } from 'react-query';
import { Order } from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/order.interface';
import { Project } from 'mdello-client-ts/dist/src/interfaces/common/project.interface';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { useNotification } from 'src/providers/notificationsProvider';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getOrder } from 'src/services/napi';

const fetchOrder = async (orderId: string): Promise<Order | undefined> => {
  const currentProject: Project | undefined = getDataFromLocalStorage(
    LocalStorageKey.CURRENT_PROJECT
  );

  if (!currentProject) return;
  const data: any | undefined = await getOrder(currentProject._id, orderId);

  if (!data) return;

  return data.data.order;
};

export const useGetOrder = (orderID: string) => {
  const { notify } = useNotification();

  return useQuery([QueryKey.ORDER], () => fetchOrder(orderID), {
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    }
  });
};
